import dayjs from 'dayjs';
import { DECADE, OLDEST_OPTION_INDEX } from '@/constants/Search';
import { RecommendSearch } from '@/modules/RecommendSearch';
import { SearchConditions } from '@/modules/SearchConditions';
import { SearchTargetProgram } from '@/modules/SearchedProgram';
import ApiRepository from './client/ApiAxiosClient';
import TbsRepository from './client/TbsJsonAxiosClient';

const resource = '';

export const useSearchRepository = () => {
  const getSearchTargetPrograms = async () => {
    const { data } = await TbsRepository.get(`${resource}/program_search.json`).catch((e) => {
      throw e;
    });

    // 不要な文字コードを削除
    data.forEach((item: SearchTargetProgram) => {
      item.description = JSON.stringify(item.description).replace(/\r?\\n|_x000D_|"/g, '') || null;
    });

    const result: SearchTargetProgram[] = data;

    return result;
  };

  const getAssistantWords = async () => {
    const { data } = await TbsRepository.get<Record<string, string[]>>(`${resource}/keyword_assist.json`).catch((e) => {
      throw e;
    });

    // NOTE: key,valueの英文字を全て小文字にする（検索時の大文字小文字の揺れ吸収の為）
    const result: Record<string, string[]> = {};
    for (const key of Object.keys(data)) {
      result[key.toLowerCase()] = data[key].map((word) => word.toLowerCase());
    }
    return result;
  };

  const getRecommendData = async () => {
    const { data } = await TbsRepository.get<RecommendSearch[]>(`${resource}/osusume.json`).catch((e) => {
      throw e;
    });
    return data.sort((a, b) => a.priority - b.priority);
  };

  const getGenreData = async () => {
    // TODO: APIの'title'が'genre'になってしまっているので修正してもらうこと
    const { data } = await TbsRepository.get<SearchConditions[]>(`${resource}/genre.json`).catch((e) => {
      throw e;
    });
    return data;
  };

  const getProductionYearsData = async (): Promise<SearchConditions[]> => {
    const currentGeneration = Math.floor(dayjs().year() / DECADE) * DECADE;
    // 現在の年代から7つぶんの年代配列を生成
    return Array(OLDEST_OPTION_INDEX + 1)
      .fill(null)
      .map((_, i) => ({
        id: ('0' + (i + 1)).slice(-2),
        value: [currentGeneration - i * DECADE],
        title:
          i === 0
            ? `${currentGeneration - i * DECADE}年以降`
            : i === 6
            ? `${currentGeneration - i * DECADE + DECADE - 1}年以前`
            : `${currentGeneration - i * DECADE}年代`,
        additionalInfo: '',
      }));
  };

  const getScheduledStatusData = async (): Promise<SearchConditions[]> => {
    return [
      { id: '01', value: [1], title: 'チャンネル1放送予定', additionalInfo: '' },
      { id: '02', value: [2], title: 'チャンネル2放送予定', additionalInfo: '' },
    ];
  };

  /**
   * 検索履歴を保存する
   * @param
   * @return
   */
  const addItem = async (userId: number, searchKeyword: string) => {
    const { data } = await ApiRepository.post(`/search-keyword/${userId}`, { search_keyword: searchKeyword }).catch(
      (e) => {
        throw e;
      }
    );
    return data;
  };

  return {
    getSearchTargetPrograms,
    getAssistantWords,
    getRecommendData,
    getGenreData,
    getProductionYearsData,
    getScheduledStatusData,
    addItem,
  };
};

export type SearchRepository = ReturnType<typeof useSearchRepository>;
